import { isEmpty } from 'lodash';
import type { AgeGapType, Gender, OccupationType, ScenePersona } from '../types';

type PendingPersonaPatch = {
  age?: string;
  occupation?: string;
  personality?: string;
  gender?: Gender;
  ageGapType?: AgeGapType;
  occupationType?: OccupationType;
  occupationDescription?: string;
  nickname?: string;
  dataUrl?: string;
};

export const nonEmpty = (value: string | undefined | null) => {
  if (value == null) return undefined;
  const trimmed = value.trim();
  return isEmpty(trimmed) ? undefined : trimmed;
};

export const updatePendingPersona = (
  prev: ScenePersona | null,
  patch: PendingPersonaPatch
): ScenePersona | null => {
  if (!prev) return prev;

  const next: ScenePersona = { ...prev };

  const occupation = nonEmpty(patch.occupation);
  if (occupation) next.occupation = occupation;

  const age = nonEmpty(patch.age);
  if (age) next.age = age;

  const personality = nonEmpty(patch.personality);
  if (personality) next.personality = personality;

  if (patch.gender != null) next.gender = patch.gender;
  if (patch.ageGapType != null) next.ageGapType = patch.ageGapType;
  if (patch.occupationType != null) next.occupationType = patch.occupationType;

  const occupationDescription = nonEmpty(patch.occupationDescription);
  if (occupationDescription) next.occupationDescription = occupationDescription;

  const nickname = nonEmpty(patch.nickname);
  if (nickname) next.nickname = nickname;

  if (patch.dataUrl != null && patch.dataUrl !== '') next.dataUrl = patch.dataUrl;

  return next;
};
